// src/views/kiddo-games/writing/WritingInput.tsx
// Kopia src/components/Writing/WritingInput.tsx — tylko dla Napisz Easy
/* eslint-disable max-len */
import React, { FC } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import KiddoSmiley from '../../../components/KiddoSmiley/KiddoSmiley';
import { isAnswerCorrect } from '../../../utils/writingAnswer';
import { recordAnswer } from '../../../services/activity';
import classes from './WritingInput.module.less';

type InputProps = {
  content: string,
  // Hasło dosłownie, z nawiasami — do sprawdzania odpowiedzi; content to podpowiedź (hasło bez nawiasów)
  term: string,
  setFeedbackInfo: any,
  setInputContent: any;
  inputContent: any;
  tryAgainButton: boolean,
  tryAgain: any,
  setNextWordButton: (varName: boolean) => void,
  setTryAgainButton: (varName: boolean) => void,
  // Dobra odpowiedź — widok czyta wtedy angielskie słowo i przechodzi do następnego
  onCorrect: () => void,
  // Dobra odpowiedź przyjęta — wpisane słowo stoi w polu bez zmian, aż widok przejdzie do następnego
  answeredCorrectly: boolean,
};

export const WritingInput: FC<InputProps> = ({
  content, term, setNextWordButton, setTryAgainButton, setFeedbackInfo, tryAgainButton, inputContent, tryAgain, setInputContent, onCorrect, answeredCorrectly,
}) => {
  const { t } = useTranslation();
  const showNextWordButton = () => {
    setNextWordButton(true);
  };

  const checkTranslation = (event: { key: string }) => {
    if (!answeredCorrectly && inputContent !== '' && event.key === 'Enter') {
      // Reguły porównania: src/utils/writingAnswer.ts (wspólne z Napisz Regular)
      const isCorrect = isAnswerCorrect(inputContent, term);

      // Monitoring aktywności — działa, gdy gra Napisz ucznia go włączyła (useActivityTracking w KiddoWritingView)
      recordAnswer(isCorrect, term);

      if (isCorrect) {
        // Słowo zostaje w polu razem z buźką, póki lektor czyta; czyści je widok przy przejściu do następnego
        showNextWordButton();
        setTryAgainButton(false);
        setFeedbackInfo(<KiddoSmiley />);
        onCorrect();
      } else {
        setTryAgainButton(true);
        // Uwaga: 'content' jest oczyszczony; żeby pokazać oryginalny termin,
        // trzeba by go przekazać jako dodatkowy prop z widoku gry.
        setFeedbackInfo(content);
      }
    }
  };

  const handleKeyUp = (event: { key: string; }) => {
    if (tryAgainButton && event.key === 'Enter' && inputContent === '') {
      setInputContent('');
    } else if (tryAgainButton && event.key === 'Enter') {
      tryAgain();
    }
  };

  return (
    <>
      <div className={classes.inputContainer}>

        <Input
          ref={(input) => { if (input != null) { input.focus(); } }}
          size="large"
          type="search"
          value={inputContent}
          readOnly={answeredCorrectly}
          placeholder={t('games:writingPlaceholder')}
          onChange={(event) => setInputContent(event.target.value)}
          onKeyPress={checkTranslation}
          className={classes.input}
          onKeyDown={handleKeyUp}
        />

      </div>
    </>
  );
};

export default WritingInput;
